<section class="scene-showcase section">
  <div class="scene-showcase__inner container">
    <app-hover-expandable-cards [cards]="expandableCards" />
  </div>
</section>
